module.exports = __webpack_public_path__ + "b5bd232e5ae7e364a0e75ba4e480dc03.svg";